<div id="spiral-bar-timeline-chartdiv" style="width: 100%; height: 500px"></div>
